import { render, staticRenderFns } from "./UnblockUser.vue?vue&type=template&id=e81914ea&"
import script from "./UnblockUser.vue?vue&type=script&lang=js&"
export * from "./UnblockUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports